<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        fab
        dark
        small
        class=""
        elevation="10"
        v-on="on"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Allowance Detail"
      text="Add Allowance Detail"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="allowancePenaltyType"
                v-validate="'required'"
                label="Allowance/Penalty Type"
                :items="allowancePenaltyTypes"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('allowancePenaltyType')"
                data-vv-name="allowancePenaltyType"
                data-vv-as="Allowance/Penalty Type"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="allowanceAmount"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('allowanceAmount')"
                data-vv-name="allowanceAmount"                
                data-vv-as="amount"  
                prefix="RM"          
                label="Amount"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="remarks"
                v-validate="'max:1000'"
                :rows="2"
                :error-messages="errors.collect('remarks')"     
                data-vv-name="remarks"           
                data-vv-as="remarks"
                label="Remarks"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    props: {
      payroll: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        allowanceAmount: null,
        allowancePenaltyTypes: [],
        allowancePenaltyType: null,
        remarks: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
        this.loadAllowancePenaltyType()
      },
    },

    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },

    methods: { 
      loadAllowancePenaltyType () {
        this.$api.allowancePenaltyTypes().list('')
          .then(res => {
            let details = this.payroll.salary_details.map(detail => {
              return detail.allowance_penalty_type_id 
            })
            this.allowancePenaltyTypes = res.data.filter(data => {
              return !details.includes(data.id)
            })
          })
      },

      prepareFormData () {
        return {
          amount: this.allowanceAmount * 100,
          allowance_penalty_type_id: this.allowancePenaltyType, 
          remarks: this.remarks,
        }
      },   
      submitForm () {
        this.$validator.validate('allowancePenaltyType', this.allowancePenaltyType)
          .then(allowancePenaltyType => {
            if (!allowancePenaltyType) return false

            this.$validator.validate('allowanceAmount', this.allowanceAmount,)
              .then(allowanceAmount => {
                if (!allowanceAmount) return false

                this.setProgressing(true)
                this.$api.salaryDetails().create(this.payroll.id, this.prepareFormData())
                  .then(res => {
                    this.$emit('created')
                    this.setProgressing(false)

                    this.setDialog(false)
                  })
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.allowanceAmount = null
        this.allowancePenaltyTypes = []
        this.allowancePenaltyType = null
        this.remarks = null
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
      loadTaxRelief () {
        this.$api.taxRelief().list()
          .then(res => {
            this.taxRelief = res.data
          })
      },
    },
  }
</script>
